<template>
  <div class="header-search-bar">
    <div class="container">
      <!-- Logo区域 -->
      <div class="logo-section">
        <router-link to="/" class="logo-link">
          <div class="logo-container">
           <el-image
              :src="logoJpg"
              :alt="'云孟择生物'"
              fit="contain"
              class="logo-image"
              loading="lazy"
            >
              <!-- <template #placeholder>
                <div class="logo-placeholder">
                  <span>{{ siteConfig.siteName.substring(0, 2) }}</span>
                </div>
              </template> -->
            
            </el-image>
            <div class="logo-text">
              <h1 class="site-name">云孟择生物</h1>
              <!-- <p class="site-slogan" v-if="siteConfig.slogan">{{ siteConfig.slogan }}</p> -->
            </div>
          </div>
        </router-link>
      </div>

      <!-- 搜索框区域 -->
      <div class="search-section">
        <!-- 搜索分类选择 -->
        <div class="search-category">
          <el-dropdown 
            @command="handleCategoryChange" 
            trigger="click"
            class="category-dropdown"
          >
            <div class="category-trigger">
              <span class="category-text">{{ currentCategory.label }}</span>
              <el-icon><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="category in searchCategories"
                  :key="category.value"
                  :command="category.value"
                  :class="{ active: currentCategory.value === category.value }"
                >
                  {{ category.label }}
                  <el-icon v-if="currentCategory.value === category.value" class="check-icon">
                    <Check />
                  </el-icon>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <div class="category-divider"></div>
        </div>

        <!-- 搜索输入框 -->
        <div class="search-input-wrapper">
          <el-input
            v-model="searchKeyword"
            :placeholder="searchPlaceholder"
            class="search-input"
            clearable
            @keyup.enter="handleSearch"
            @clear="handleClear"
          >
            <template #prefix>
              <el-icon class="search-icon"><Search /></el-icon>
            </template>
          </el-input>
        </div>

        <!-- 搜索按钮 -->
        <el-button
          type="primary"
          @click="handleSearch"
          class="search-button"
          :loading="searching"
        >
          <template #default>
            <el-icon><Search /></el-icon>
            <span class="button-text">搜索</span>
          </template>
        </el-button>

        <!-- 热门搜索提示 -->
        <!-- <div class="hot-search" v-if="showHotSearch && hotSearchList.length > 0">
          <span class="hot-title">热门搜索：</span>
          <div class="hot-tags">
            <el-tag
              v-for="(item, index) in hotSearchList"
              :key="index"
              type="info"
              size="small"
              class="hot-tag"
              @click="handleHotSearchClick(item.keyword)"
            >
              {{ item.keyword }}
              <el-tag
                v-if="item.isHot"
                type="danger"
                size="mini"
                class="hot-icon"
              >
                热
              </el-tag>
            </el-tag>
          </div>
        </div> -->

        <!-- 搜索建议 -->
        <div
          v-if="showSuggestions && searchSuggestions.length > 0"
          class="search-suggestions"
          ref="suggestionsRef"
        >
          <div class="suggestions-header">
            <span class="suggestions-title">搜索建议</span>
            <el-button type="text" size="small" @click="clearSuggestions">
              清除记录
            </el-button>
          </div>
          <div class="suggestions-list">
            <div
              v-for="(item, index) in searchSuggestions"
              :key="index"
              class="suggestion-item"
              :class="{ 'is-history': item.type === 'history' }"
              @click="handleSuggestionClick(item)"
            >
              <div class="suggestion-content">
                <el-icon v-if="item.type === 'history'" class="suggestion-icon">
                  <Clock />
                </el-icon>
                <span class="suggestion-text">{{ item.keyword }}</span>
                <span v-if="item.count" class="suggestion-count">
                  {{ formatCount(item.count) }}条结果
                </span>
              </div>
              <el-button
                v-if="item.type === 'history'"
                type="text"
                size="small"
                class="delete-btn"
                @click.stop="deleteSearchHistory(item.keyword)"
              >
                <el-icon><Close /></el-icon>
              </el-button>
            </div>
          </div>
          
          <!-- 相关分类建议 -->
          <div 
            v-if="relatedCategories.length > 0" 
            class="related-categories"
          >
            <div class="related-title">相关分类</div>
            <div class="category-tags">
              <el-tag
                v-for="category in relatedCategories"
                :key="category.id"
                type="info"
                size="small"
                class="category-tag"
                @click="handleCategorySearch(category)"
              >
                {{ category.name }}
                <span class="category-count">({{ category.count }})</span>
              </el-tag>
            </div>
          </div>
        </div>
      </div>

      <!-- 功能菜单区域 -->
      <div class="action-section">
        <!-- 购物车 -->
        <!-- <div class="action-item cart-item" @click="goToCart">
          <el-badge 
            :value="cartCount" 
            :max="99" 
            :hidden="cartCount === 0"
            class="cart-badge"
          >
            <div class="action-content">
              <el-icon class="action-icon"><ShoppingCart /></el-icon>
              <span class="action-text">购物车</span>
            </div>
          </el-badge>
        </div>

        <!-- 收藏夹 -->
        <!-- <div class="action-item wishlist-item" @click="goToWishlist"> -->
          <!-- <el-badge 
            :value="wishlistCount" 
            :max="99" 
            :hidden="wishlistCount === 0"
          > -->
            <!-- <div class="action-content"> -->
              <!-- <el-icon class="action-icon"><Star /></el-icon> -->
              <!-- <span class="action-text">收藏</span> -->
            <!-- </div> -->
          <!-- </el-badge> -->
        <!-- </div> -->

        <!-- 用户菜单 -->
        <!-- <div class="action-item user-item">
          <el-dropdown @command="handleUserCommand" trigger="click">
            <div class="user-trigger">
              <el-avatar :size="32" :src="userAvatar" class="user-avatar">
                {{ userInitials }}
              </el-avatar>
              <span class="user-name" v-if="isLoggedIn">{{ userName }}</span>
              <span class="user-name" v-else>登录/注册</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <template v-if="isLoggedIn">
                  <el-dropdown-item command="profile">
                    <el-icon><User /></el-icon>
                    个人中心
                  </el-dropdown-item>
                  <el-dropdown-item command="orders">
                    <el-icon><Document /></el-icon>
                    我的订单
                  </el-dropdown-item>
                  <el-dropdown-item command="address">
                    <el-icon><Location /></el-icon>
                    收货地址
                  </el-dropdown-item>
                  <el-dropdown-item divided command="logout">
                    <el-icon><SwitchButton /></el-icon>
                    退出登录
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item command="login">
                    <el-icon><User /></el-icon>
                    立即登录
                  </el-dropdown-item>
                  <el-dropdown-item command="register">
                    <el-icon><EditPen /></el-icon>
                    免费注册
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div> -->

        <!-- 移动端菜单按钮 -->
        <!-- <div class="action-item mobile-menu-item" @click="toggleMobileMenu">
          <el-icon class="menu-icon"><Menu /></el-icon>
        </div>  -->
        <!-- 电话 -->
        <div class="action-phone">
          <el-icon class="phone-outline">
            <Phone />
          </el-icon>
          <span class="text">13166409925</span>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div v-if="showMobileMenu" class="mobile-menu-overlay" @click="toggleMobileMenu">
      <div class="mobile-menu" @click.stop>
        <div class="mobile-menu-header">
          <div class="mobile-user-info" v-if="isLoggedIn">
            <el-avatar :size="48" :src="userAvatar" class="mobile-avatar">
              {{ userInitials }}
            </el-avatar>
            <div class="mobile-user-details">
              <div class="mobile-user-name">{{ userName }}</div>
              <div class="mobile-user-phone">{{ userPhone }}</div>
            </div>
          </div>
          <div class="mobile-login-prompt" v-else>
            <el-button type="primary" @click="goToLogin">立即登录</el-button>
            <el-button @click="goToRegister">免费注册</el-button>
          </div>
        </div>
        
        <div class="mobile-menu-content">
          <div class="mobile-menu-item" @click="goToCategory('all')">
            <el-icon><Grid /></el-icon>
            <span>全部商品</span>
          </div>
          <div class="mobile-menu-item" @click="goToCategory('elisa')">
            <el-icon><Box /></el-icon>
            <span>ELISA试剂盒</span>
          </div>
          <div class="mobile-menu-item" @click="goToCategory('antibody')">
            <el-icon><Sunny /></el-icon>
            <span>抗体</span>
          </div>
          <div class="mobile-menu-item" @click="goToCategory('protein')">
            <el-icon><Cpu /></el-icon>
            <span>重组蛋白</span>
          </div>
          <div class="mobile-menu-item" @click="goToCategory('cytokine')">
            <el-icon><Star /></el-icon>
            <span>细胞因子</span>
          </div>
          <div class="mobile-menu-divider"></div>
          <div class="mobile-menu-item" @click="goToCart">
            <el-badge :value="cartCount" :max="99" :hidden="cartCount === 0">
              <el-icon><ShoppingCart /></el-icon>
              <span>购物车</span>
            </el-badge>
          </div>
          <div class="mobile-menu-item" @click="goToWishlist">
            <el-badge :value="wishlistCount" :max="99" :hidden="wishlistCount === 0">
              <el-icon><Star /></el-icon>
              <span>我的收藏</span>
            </el-badge>
          </div>
          <div class="mobile-menu-item" @click="goToOrders">
            <el-icon><Document /></el-icon>
            <span>我的订单</span>
          </div>
          <div class="mobile-menu-item" @click="goToProfile">
            <el-icon><User /></el-icon>
            <span>个人中心</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useClipboard } from '@vueuse/core'
// import { useCartStore } from '@/stores/cart'
// import { useWishlistStore } from '@/stores/wishlist'
// import { useUserStore } from '@/stores/user'
// import { searchProducts, getSearchSuggestions } from '@/api/products'
import type { Product, ProductCategory } from '@/types/product'
import {
 logoJpg
} from "../../utils/home_util.js";
// 图标导入
import {
  Picture,
  ArrowDown,
  Check,
  Search,
  Clock,
  Close,
  ShoppingCart,
  Star,
  User,
  Document,
  Location,
  SwitchButton,
  EditPen,
  Menu,
  Grid,
  Box,
  Sunny,
  Cpu,
  Phone
} from '@element-plus/icons-vue'

// Props定义
interface Props {
  showHotSearch?: boolean
  fixed?: boolean
  transparent?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showHotSearch: true,
  fixed: false,
  transparent: false
})

// Emits定义
const emit = defineEmits<{
  'search': [keyword: string, category?: string]
  'category-change': [category: string]
  'logo-click': []
}>()

// 路由和状态
const router = useRouter()
const route = useRoute()
// const cartStore = useCartStore()
// const wishlistStore = useWishlistStore()
// const userStore = useUserStore()

// 响应式数据
const searchKeyword = ref('')
const currentCategory = ref({ value: 'all', label: '全部商品' })
const searching = ref(false)
const showSuggestions = ref(false)
const showMobileMenu = ref(false)
const searchSuggestions = ref<Array<{
  keyword: string
  type: 'suggestion' | 'history'
  count?: number
}>>([])
const relatedCategories = ref<ProductCategory[]>([])
const searchTimer = ref<NodeJS.Timeout>()

// 站点配置
const siteConfig = ref({
  siteName: '联科生物',
  slogan: '高品质生命科学研究试剂',
  logoUrl: '/logo.png',
  logoText: 'LK BIO'
})

// 搜索分类选项
const searchCategories = ref([
  { value: 'all', label: '全部' },
  { value: 'elisa', label: 'ELISA' },
  { value: 'sh', label: '生化' },
])

// 热门搜索
const hotSearchList = ref([
  { keyword: 'Human IL-6', isHot: true },
  { keyword: 'ELISA试剂盒', isHot: false },
  { keyword: '抗体', isHot: false },
  { keyword: '重组蛋白', isHot: false },
  { keyword: '细胞因子', isHot: false }
])

// 搜索历史
const searchHistory = ref<string[]>([])

// 计算属性
const searchPlaceholder = computed(() => {
  if (currentCategory.value.value === 'all') {
    return '搜索商品或货号'
  }
  return `在${currentCategory.value.label}中搜索`
})

// const cartCount = computed(() => cartStore.totalItems)
// const wishlistCount = computed(() => wishlistStore.items.length)

// const isLoggedIn = computed(() => userStore.isLoggedIn)
// const userName = computed(() => userStore.userInfo?.name || '')
// const userAvatar = computed(() => userStore.userInfo?.avatar || '')
// const userPhone = computed(() => userStore.userInfo?.phone || '')
// const userInitials = computed(() => {
//   if (!userName.value) return 'U'
//   return userName.value.charAt(0).toUpperCase()
// })

// 方法
const handleSearchInput = () => {
  if (searchTimer.value) {
    clearTimeout(searchTimer.value)
  }
  
  if (searchKeyword.value.trim().length >= 1) {
    searchTimer.value = setTimeout(async () => {
      // await loadSearchSuggestions()
      handleSearch()
    }, 300)
  } else {
    showSuggestions.value = false
  }
}

const loadSearchSuggestions = async () => {
  if (!searchKeyword.value.trim()) {
    showSuggestions.value = false
    return
  }
  
  try {
    const keyword = searchKeyword.value.trim()
    
    // 加载搜索建议
    const suggestions = await getSearchSuggestions(keyword, {
      category: currentCategory.value.value,
      limit: 8
    })
    
    searchSuggestions.value = suggestions.data
    
    // 加载相关分类
    // const categories = await getRelatedCategories(keyword)
    // relatedCategories.value = categories.data
    
    // 合并搜索历史
    const history = getSearchHistory()
      .filter(h => h.toLowerCase().includes(keyword.toLowerCase()))
      .slice(0, 5)
      .map(keyword => ({ keyword, type: 'history' as const }))
    
    if (history.length > 0) {
      searchSuggestions.value = [...history, ...searchSuggestions.value]
    }
    
    showSuggestions.value = true
  } catch (error) {
    console.error('加载搜索建议失败:', error)
    showSuggestions.value = false
  }
}

const handleSearch = () => {
  const keyword = searchKeyword.value.trim()
  if (!keyword) {
    ElMessage.warning('请输入搜索关键词')
    return
  }
  
  searching.value = true
  
  // 保存搜索历史
  saveSearchHistory(keyword)
  
  // 触发搜索
  emit('search', keyword, currentCategory.value.value)
  
  // 跳转到搜索结果页
  router.push({
    path: '/category',
    query: {
      keyword,
      // category: currentCategory.value !== 'all' ? currentCategory.value : undefined
    }
  })
  
  // 关闭搜索建议
  showSuggestions.value = false
  
  // 重置搜索状态
  setTimeout(() => {
    searching.value = false
  }, 500)
}

const handleClear = () => {
  searchKeyword.value = ''
  showSuggestions.value = false
}

const handleCategoryChange = (categoryValue: string) => {
  const category = searchCategories.value.find(c => c.value === categoryValue)
  if (category) {
    currentCategory.value = category
    emit('category-change', categoryValue)
    
    // 如果有关键词，重新加载建议
    if (searchKeyword.value.trim()) {
      loadSearchSuggestions()
    }
  }
}

const handleHotSearchClick = (keyword: string) => {
  searchKeyword.value = keyword
  handleSearch()
}

const handleSuggestionClick = (item: any) => {
  searchKeyword.value = item.keyword
  handleSearch()
}

const handleCategorySearch = (category: ProductCategory) => {
  router.push({
    path: '/category',
    query: { type: category.slug }
  })
  showSuggestions.value = false
}

const clearSuggestions = () => {
  clearSearchHistory()
  searchSuggestions.value = searchSuggestions.value.filter(item => item.type !== 'history')
}

const deleteSearchHistory = (keyword: string) => {
  const history = getSearchHistory()
  const filtered = history.filter(h => h !== keyword)
  localStorage.setItem('searchHistory', JSON.stringify(filtered))
  searchHistory.value = filtered
  
  // 从建议中移除
  searchSuggestions.value = searchSuggestions.value.filter(item => 
    !(item.type === 'history' && item.keyword === keyword)
  )
}

const formatCount = (count: number): string => {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`
  }
  return count.toString()
}

// 搜索历史管理
const saveSearchHistory = (keyword: string) => {
  let history = getSearchHistory()
  
  // 移除重复项
  history = history.filter(h => h !== keyword)
  
  // 添加到开头
  history.unshift(keyword)
  
  // 只保留最近的10条
  if (history.length > 10) {
    history = history.slice(0, 10)
  }
  
  localStorage.setItem('searchHistory', JSON.stringify(history))
  searchHistory.value = history
}

const getSearchHistory = (): string[] => {
  const history = localStorage.getItem('searchHistory')
  return history ? JSON.parse(history) : []
}

const clearSearchHistory = () => {
  localStorage.removeItem('searchHistory')
  searchHistory.value = []
}

// 用户相关操作
const handleUserCommand = (command: string) => {
  switch (command) {
    case 'login':
      router.push('/login')
      break
    case 'register':
      router.push('/register')
      break
    case 'profile':
      router.push('/profile')
      break
    case 'orders':
      router.push('/orders')
      break
    case 'address':
      router.push('/address')
      break
    case 'logout':
      handleLogout()
      break
  }
}

const handleLogout = () => {
  userStore.logout()
  ElMessage.success('已退出登录')
  router.push('/')
}

// 导航方法
const goToCart = () => {
  router.push('/cart')
}

const goToWishlist = () => {
  router.push('/wishlist')
}

const goToLogin = () => {
  router.push('/login')
  showMobileMenu.value = false
}

const goToRegister = () => {
  router.push('/register')
  showMobileMenu.value = false
}

const goToProfile = () => {
  router.push('/profile')
  showMobileMenu.value = false
}

const goToOrders = () => {
  router.push('/orders')
  showMobileMenu.value = false
}

const goToCategory = (categorySlug: string) => {
  router.push({
    path: '/category',
    query: { type: categorySlug }
  })
  showMobileMenu.value = false
}

const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value
}

// 点击外部关闭搜索建议
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  const suggestionsElement = document.querySelector('.search-suggestions')
  
  if (suggestionsElement && !suggestionsElement.contains(target) && 
      !target.closest('.search-input-wrapper') && 
      !target.closest('.search-category')) {
    showSuggestions.value = false
  }
}

// 生命周期
onMounted(() => {
  // 加载搜索历史
  searchHistory.value = getSearchHistory()
  
  // 监听外部点击
  document.addEventListener('click', handleClickOutside)
  
  // 从路由参数初始化搜索关键词
  if (route.query.keyword) {
    searchKeyword.value = route.query.keyword as string
  }
  
  // 从路由参数初始化分类
  if (route.query.category) {
    const category = searchCategories.value.find(c => c.value === route.query.category)
    if (category) {
      currentCategory.value = category
    }
  }
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
  if (searchTimer.value) {
    clearTimeout(searchTimer.value)
  }
})

// 监听路由变化
watch(
  () => route.query,
  (query) => {
    if (query.keyword && query.keyword !== searchKeyword.value) {
      searchKeyword.value = query.keyword as string
    }
  }
)
</script>

<style scoped lang="scss">
.header-search-bar {
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
  
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    animation: slideDown 0.3s ease;
  }
  
  &.transparent {
    background: transparent;
    box-shadow: none;
    
    .container {
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      border-radius: 0 0 12px 12px;
    }
  }
  
  .container {
    display: flex;
    align-items: center;
    padding: 12px 24px;
    max-width: 1400px;
    margin: 0 auto;
    transition: all 0.3s ease;
    
    @media (max-width: 768px) {
      padding: 8px 16px;
    }
  }
}

/* Logo区域 */
.logo-section {
  flex-shrink: 0;
  margin-right: 40px;
  
  @media (max-width: 1024px) {
    margin-right: 24px;
  }
  
  @media (max-width: 768px) {
    margin-right: 16px;
  }
  
  .logo-link {
    text-decoration: none;
    color: inherit;
    display: block;
    
    &:hover {
      opacity: 0.9;
    }
  }
  
  .logo-container {
    display: flex;
    align-items: center;
    gap: 12px;
    
    .logo-image {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      overflow: hidden;
      
      @media (max-width: 768px) {
        width: 40px;
        height: 40px;
      }
    }
    
    .logo-placeholder,
    .logo-error {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, var(--el-color-primary) 0%, var(--el-color-primary-light-3) 100%);
      color: white;
      font-weight: bold;
      
      span {
        font-size: 20px;
      }
      
      .el-icon {
        font-size: 24px;
      }
    }
    
    .logo-text {
      .site-name {
        font-size: 20px;
        font-weight: bold;
        color: var(--el-color-primary);
        margin: 0;
        line-height: 1.2;
        
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
      
      .site-slogan {
        font-size: 12px;
        color: var(--el-text-color-secondary);
        margin: 2px 0 0 0;
        
        @media (max-width: 768px) {
          display: none;
        }
      }
    }
  }
}

/* 搜索区域 */
.search-section {
  flex: 1;
  position: relative;
  min-width: 0;
  margin: 0 32px;
  
  @media (max-width: 1024px) {
    margin: 0 16px;
  }
  
  .search-category {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    
    .category-dropdown {
      height: 100%;
      
      .category-trigger {
        display: flex;
        align-items: center;
        gap: 4px;
        height: 100%;
        padding: 0 16px;
        background: var(--el-fill-color-light);
        border-right: 1px solid var(--el-border-color);
        border-radius: 8px 0 0 8px;
        cursor: pointer;
        transition: all 0.2s;
        
        &:hover {
          background: var(--el-fill-color);
        }
        
        .category-text {
          font-size: 14px;
          color: var(--el-text-color-primary);
          white-space: nowrap;
        }
        
        .el-icon {
          font-size: 12px;
          color: var(--el-text-color-secondary);
        }
      }
    }
    
    .category-divider {
      position: absolute;
      right: 0;
      top: 8px;
      bottom: 8px;
      width: 1px;
      background: var(--el-border-color);
    }
  }
  
  .search-input-wrapper {
    margin-left: 70px;
    
    @media (max-width: 768px) {
      margin-left: 0;
    }
    
    .search-input {
      :deep(.el-input__wrapper) {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s;
        
        &:hover {
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
        }
        
        &.is-focus {
          box-shadow: 0 2px 12px rgba(var(--el-color-primary-rgb), 0.2);
        }
      }
      
      :deep(.el-input__prefix) {
        padding-left: 12px;
      }
      
      .search-icon {
        color: var(--el-text-color-secondary);
      }
    }
  }
  
  .search-button {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 0 8px 8px 0;
    padding: 0 24px;
    font-weight: 500;
    
    @media (max-width: 768px) {
      padding: 0 16px;
      
      .button-text {
        display: none;
      }
    }
  }
  
  .hot-search {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    
    .hot-title {
      font-size: 12px;
      color: var(--el-text-color-secondary);
      white-space: nowrap;
    }
    
    .hot-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      
      .hot-tag {
        cursor: pointer;
        transition: all 0.2s;
        
        &:hover {
          background: var(--el-color-primary-light-9);
          border-color: var(--el-color-primary-light-7);
          color: var(--el-color-primary);
        }
        
        .hot-icon {
          margin-left: 4px;
          border: none;
        }
      }
    }
  }
  
  .search-suggestions {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid var(--el-border-color);
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    max-height: 400px;
    overflow-y: auto;
    animation: fadeInUp 0.2s ease;
    
    .suggestions-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      border-bottom: 1px solid var(--el-border-color-light);
      
      .suggestions-title {
        font-size: 14px;
        font-weight: 500;
        color: var(--el-text-color-primary);
      }
    }
    
    .suggestions-list {
      .suggestion-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        cursor: pointer;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: var(--el-fill-color-light);
        }
        
        &.is-history {
          .suggestion-icon {
            color: var(--el-text-color-secondary);
          }
        }
        
        .suggestion-content {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          min-width: 0;
          
          .suggestion-icon {
            font-size: 14px;
            flex-shrink: 0;
          }
          
          .suggestion-text {
            flex: 1;
            font-size: 14px;
            color: var(--el-text-color-primary);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          
          .suggestion-count {
            font-size: 12px;
            color: var(--el-text-color-secondary);
            flex-shrink: 0;
          }
        }
        
        .delete-btn {
          color: var(--el-text-color-secondary);
          padding: 0;
          width: 24px;
          height: 24px;
          
          &:hover {
            color: var(--el-color-danger);
          }
        }
      }
    }
    
    .related-categories {
      padding: 16px;
      border-top: 1px solid var(--el-border-color-light);
      
      .related-title {
        font-size: 14px;
        font-weight: 500;
        color: var(--el-text-color-primary);
        margin-bottom: 8px;
      }
      
      .category-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        
        .category-tag {
          cursor: pointer;
          transition: all 0.2s;
          
          &:hover {
            background: var(--el-color-primary-light-9);
            border-color: var(--el-color-primary-light-7);
            color: var(--el-color-primary);
          }
          
          .category-count {
            font-size: 11px;
            color: var(--el-text-color-secondary);
          }
        }
      }
    }
  }
}

/* 功能菜单区域 */
.action-section {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    gap: 16px;
  }
  
  .action-item {
    cursor: pointer;
    position: relative;
    
    &:hover {
      .action-content {
        .action-icon {
          color: var(--el-color-primary);
          transform: translateY(-2px);
        }
        
        .action-text {
          color: var(--el-color-primary);
        }
      }
    }
    
    .action-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      transition: all 0.2s;
      
      .action-icon {
        font-size: 24px;
        color: var(--el-text-color-secondary);
        transition: all 0.2s;
      }
      
      .action-text {
        font-size: 12px;
        color: var(--el-text-color-secondary);
        transition: color 0.2s;
      }
    }
    
    .cart-badge {
      :deep(.el-badge__content) {
        top: -8px;
        right: -8px;
      }
    }
    
    &.user-item {
      .user-trigger {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px;
        border-radius: 20px;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: var(--el-fill-color-light);
        }
        
        .user-avatar {
          background: linear-gradient(135deg, var(--el-color-primary) 0%, var(--el-color-primary-light-3) 100%);
        }
        
        .user-name {
          font-size: 14px;
          color: var(--el-text-color-primary);
          white-space: nowrap;
          
          @media (max-width: 768px) {
            display: none;
          }
        }
      }
    }
    
    &.mobile-menu-item {
      display: none;
      
      @media (max-width: 768px) {
        display: block;
      }
      
      .menu-icon {
        font-size: 24px;
        color: var(--el-text-color-primary);
      }
    }
  }
}

/* 移动端菜单 */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  animation: fadeIn 0.3s ease;
  
  .mobile-menu {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 280px;
    background: white;
    box-shadow: -2px 0 12px rgba(0, 0, 0, 0.1);
    animation: slideInRight 0.3s ease;
    overflow-y: auto;
    
    .mobile-menu-header {
      padding: 24px 20px;
      background: linear-gradient(135deg, var(--el-color-primary) 0%, var(--el-color-primary-light-3) 100%);
      color: white;
      
      .mobile-user-info {
        display: flex;
        align-items: center;
        gap: 16px;
        
        .mobile-avatar {
          border: 2px solid white;
        }
        
        .mobile-user-details {
          .mobile-user-name {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 4px;
          }
          
          .mobile-user-phone {
            font-size: 14px;
            opacity: 0.9;
          }
        }
      }
      
      .mobile-login-prompt {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
    }
    
    .mobile-menu-content {
      padding: 16px 0;
      
      .mobile-menu-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px 20px;
        cursor: pointer;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: var(--el-fill-color-light);
        }
        
        .el-icon {
          font-size: 20px;
          color: var(--el-text-color-secondary);
        }
        
        span {
          font-size: 15px;
          color: var(--el-text-color-primary);
        }
        
        :deep(.el-badge) {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
        }
      }
      
      .mobile-menu-divider {
        height: 1px;
        background: var(--el-border-color-light);
        margin: 8px 20px;
      }
    }
  }
}
.action-phone{
  width: 24px;
  font-size: 20px;
  display: flex;
  justify-content:space-evenly;
  align-items:center;
  cursor: pointer;
  .text{
    margin-left: 16px;
  }
  &:hover{
    color: var(--el-color-primary);
  }
}

/* 动画 */
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .search-section {
    .search-category {
      display: none;
    }
    
    .search-input-wrapper {
      .search-input {
        :deep(.el-input__wrapper) {
          border-radius: 8px;
        }
      }
    }
    
    .search-button {
      border-radius: 8px;
    }
    
    .hot-search {
      display: none;
    }
  }
  
  .action-section {
    .action-item {
      &:not(.mobile-menu-item) {
        .action-text {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .container {
    padding: 8px 12px;
  }
  
  .logo-section {
    .logo-container {
      .logo-text {
        .site-name {
          font-size: 14px;
        }
      }
    }
  }
  
  .search-section {
    margin: 0 12px;
  }
}
</style>